<ng-select
  [items]="member$ | async"
  bindValue="id"
  bindLabel="username"
  [typeahead]="memberInput$"
  [loading]="memberLoading"
  (change)="onSelectChange($event)"
  [typeToSearchText]="'TYPE_MEMBER_TO_SEARCH' | translate"
  [placeholder]="(emptyIsAll ? 'ALL_MEMBERS' : 'CHOOSE_MEMBER') | translate"
>
</ng-select>
